import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchBeneficiaries, fetchSingleBeneficiary } from "./thunkActions";

interface InitialState {
    isLoading: boolean;
    beneficiaries: any;
    singleBeneficiary: any;
    isFetchingbeneficiary: boolean
}

const initialState: InitialState = {
    beneficiaries: [],
    isLoading: false,
    singleBeneficiary: null,
    isFetchingbeneficiary: false
};

const beneficiariesSlice = createSlice({
    name: "beneficiaries",
    initialState,
    reducers: {
        clearBeneficiaries: (state, action: PayloadAction<boolean>) => {
          if (action.payload) {
            state.beneficiaries = [];
          }
        },
        clearBeneficiary: (state, action: PayloadAction<boolean>) => {
          if (action.payload) {
            state.singleBeneficiary = null;
          }
        }
    },
    extraReducers(builder) {
        builder.addCase(fetchBeneficiaries.pending, (state) => {
            state.beneficiaries = [];
            state.isLoading = true;
        })
        .addCase(fetchBeneficiaries.fulfilled, (state, action) => {
            state.beneficiaries = action.payload;
            state.isLoading = false;
        })
        .addCase(fetchBeneficiaries.rejected, (state) => {
            state.isLoading = false;
        });

        builder.addCase(fetchSingleBeneficiary.pending, (state) => {
            state.isFetchingbeneficiary = true;
        })
        .addCase(fetchSingleBeneficiary.fulfilled, (state, action) => {
            state.singleBeneficiary = action.payload;
            state.isFetchingbeneficiary = false;
        })
        .addCase(fetchSingleBeneficiary.rejected, (state) => {
            state.isFetchingbeneficiary = false;
        });
    }
})
export default beneficiariesSlice.reducer;
export const { clearBeneficiaries, clearBeneficiary } = beneficiariesSlice.actions;
export * from "./thunkActions";